'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;
// import { HelmetSEO } from 'components';


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _VoucherCard = require('../../components/Box/VoucherCard');

var _VoucherCard2 = _interopRequireDefault(_VoucherCard);

var _reactBootstrap = require('react-bootstrap');

var _support = require('helpers/support');

var _voucher = require('redux/modules/voucher');

var voucherActions = _interopRequireWildcard(_voucher);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { asyncConnect } from 'redux-async-connect';
// @asyncConnect([
//   {
//     promise: ({ store: { dispatch, getState } }) => {
//       const promises = [];
//       if (!setupActions.isSeoLoaded(getState())) {
//         promises.push(dispatch(setupActions.loadSeo()));
//       }
//       return Promise.all(promises);
//     },
//   },
// ])
var GeneralCampaignListPromotion = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    REWARD_CAMPAIGN: state.voucher.REWARD_CAMPAIGN
  };
}, {
  getRewardCampaign: voucherActions.getRewardCampaign
}), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(GeneralCampaignListPromotion, _Component);

  function GeneralCampaignListPromotion(props) {
    (0, _classCallCheck3.default)(this, GeneralCampaignListPromotion);
    return (0, _possibleConstructorReturn3.default)(this, (GeneralCampaignListPromotion.__proto__ || (0, _getPrototypeOf2.default)(GeneralCampaignListPromotion)).call(this, props));
  }

  (0, _createClass3.default)(GeneralCampaignListPromotion, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var campaignHandle = this.props.params.campaignHandle;

      if (campaignHandle) {
        this.props.getRewardCampaign(campaignHandle);
      }
    }
  }, {
    key: 'renderPackageService',
    value: function renderPackageService(packageService, index) {
      // const item = {
      //   name: service.name,
      //   countDown: Helper.distanceTwoDate(campaign.limitDate),
      //   image: packageService.image,
      //   newPrice: packageService.displayValue,
      //   oldPrice: service.price,
      //   shopName: shop.name,
      //   address: shop.addressDisplay ? shop.addressDisplay : shop.address,
      //   exu: packageService.pointReward,
      //   handle: packageService.handle,
      //   packId: packageService._id,
      //   expired: new Date() > moment(campaign.endDate),
      //   shop,
      //   service,
      // };
      var item = _support.Helper.parsePackageServiceToCard(packageService);
      return _react2.default.createElement(
        _reactBootstrap.Col,
        { md: 3, key: index },
        _react2.default.createElement(_VoucherCard2.default, { data: item })
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./Promotion.scss');
      var data = this.props.REWARD_CAMPAIGN.data;

      var campaignName = data && data.length ? data[0].campaign.name : 'Đang chờ dữ liệu';
      return _react2.default.createElement(
        'div',
        { className: styles.promotionDetail + ' container' },
        _react2.default.createElement(_reactHelmet2.default, { title: campaignName }),
        _react2.default.createElement(
          'div',
          { className: styles.header },
          _react2.default.createElement('div', { className: styles.borderHighlight }),
          _react2.default.createElement(
            'div',
            { className: styles.title },
            campaignName
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.miniText },
          'C\xE1c spa c\xF3 ch\u01B0\u01A1ng tr\xECnh \u01B0u \u0111\xE3i'
        ),
        _react2.default.createElement(
          'div',
          { className: styles.listPromotion },
          _react2.default.createElement(
            _reactBootstrap.Row,
            null,
            data && data.map(function (item, index) {
              return _this2.renderPackageService(item, index);
            })
          )
        )
      );
    }
  }]);
  return GeneralCampaignListPromotion;
}(_react.Component), _class2.propTypes = {
  params: _react.PropTypes.object,
  REWARD_CAMPAIGN: _react.PropTypes.object,
  getRewardCampaign: _react.PropTypes.func
}, _temp)) || _class);
exports.default = GeneralCampaignListPromotion;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Promotion/GeneralCampaignListPromotion.js
// module id = 1687
// module chunks = 0